const $_documentContainer = document.createElement('template');

export const PaperMenuButtonStyle = `
  paper-menu-button {
    --paper-menu-button-content: {
      border-radius: 16px;
    };
  }
`;

$_documentContainer.innerHTML = `<dom-module id="paper-menu-button-style">
  <template>
    <style>
      ${PaperMenuButtonStyle}
    </style>
  </template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);
